/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum CreativeType {
  AUDIO = "AUDIO",
  DISPLAY = "DISPLAY",
  VIDEO = "VIDEO",
}

export enum ForecastingStatus {
  FAILED = "FAILED",
  LOADED = "LOADED",
  LOADING = "LOADING",
  NOT_FOUND = "NOT_FOUND",
  NOT_LOADED = "NOT_LOADED",
}

export enum POIType {
  POLYGON = "POLYGON",
  PROXIMITY = "PROXIMITY",
}

export enum SearchType {
  CITY = "CITY",
  COUNTRY = "COUNTRY",
  METRO = "METRO",
  PUBLISHER = "PUBLISHER",
  REGION = "REGION",
  VENUE_TYPE = "VENUE_TYPE",
  ZIP = "ZIP",
}

export interface PointOfInterestInput {
  latitude: number;
  longitude: number;
  radiusInMeters?: number | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
